import { useEffect } from "react";

import { UserTagCategoryOverview, UserTagOverview } from "api/generated/model";
import { TagsData } from "components/tag/types";

import { TagsSelectFilter } from "../tagsFilter/tagsSelectFilter";

interface TSTValidTagsSelectFilterProps {
    placeholder?: string;
    uniqueTagIds: string[];
    tags: UserTagOverview[] | TagsData["tags"];
    tagCategories: UserTagCategoryOverview[] | TagsData["tagCategories"];
    setFilterValue: (value: string[] | null) => void;
    value: string[] | null;
}

export function TSTValidTagsSelectFilter({
    placeholder,
    uniqueTagIds,
    tags,
    tagCategories,
    setFilterValue,
    value,
}: TSTValidTagsSelectFilterProps) {
    // Filter out any invalid tag IDs that don't exist in uniqueTagIds
    const filteredValue =
        value?.filter((tagId) => uniqueTagIds.includes(tagId)) || null;

    // Update the column filter value if the filtered value differs from the original
    useEffect(() => {
        if (value && filteredValue && value.length !== filteredValue.length) {
            // If there are no valid tags left, set to null, otherwise use filtered value
            const newValue = filteredValue.length > 0 ? filteredValue : null;
            setFilterValue(newValue);
        }
    }, [value, filteredValue, setFilterValue]);

    return (
        <TagsSelectFilter
            setFilterValue={setFilterValue}
            tagCategories={tagCategories}
            placeholder={placeholder}
            tags={tags}
            uniqueTagIds={uniqueTagIds}
            value={filteredValue}
        />
    );
}
